<template>
    <ChildPage page-type="companies-child-page" />
</template>
<script lang="ts" setup>
    import {useWebsitePageView} from '#imports';
    import ChildPage from '~/components/ChildPage.vue';

    useWebsitePageView('cms', 'companies');
</script>
